import * as React from 'react';
import { ZoomedImage } from '../../../../types';

interface ZoomerWrapperProps {
  index: number;
  children: React.ReactElement;
  setZoomedImage: React.Dispatch<React.SetStateAction<ZoomedImage | undefined>>;
}

function ZoomerImageWrapper({ index, setZoomedImage, children }: ZoomerWrapperProps): React.ReactElement {
  return (
    <>
      <button
        className="zoomer__wrapper"
        type="button"
        onClick={(event: React.MouseEvent<HTMLButtonElement, MouseEvent>): void => {
          const height = (event.target as HTMLButtonElement).offsetHeight;
          const width = (event.target as HTMLButtonElement).offsetWidth;
          setZoomedImage({ src: children.props.src, index, height, width });
        }}
      >
        Zoom Image
      </button>
      {children}
    </>
  );
}

export default ZoomerImageWrapper;
